import StorageDriver from './StorageDriver'

export default class LocalStorageDriver extends StorageDriver {
  setItem (key, value) {
    return new Promise((resolve, reject) => {
      localStorage.setItem(key, JSON.stringify(value))

      return resolve()
    })
  }

  getItem (key) {
    let data = localStorage.getItem(key)

    if (typeof (data) === 'string') {
      data = JSON.parse(data)
    }

    return new Promise((resolve, reject) => {
      return resolve(data)
    })
  }
}
